import { render } from "./DungeonMapDesktop.vue?vue&type=template&id=7d46b652&scoped=true&lang=html"
import script from "./DungeonMapDesktop.vue?vue&type=script&lang=js"
export * from "./DungeonMapDesktop.vue?vue&type=script&lang=js"

import "./DungeonMapDesktop.vue?vue&type=style&index=0&id=7d46b652&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d46b652"]])

export default __exports__